var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58428",
    "data-name": "Group 58428",
    transform: "translate(-276 -90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7987",
    "data-name": "Rectangle 7987",
    width: 70,
    height: 70,
    rx: 17,
    transform: "translate(276 90)",
    fill: "#3ea598",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58421",
    "data-name": "Group 58421",
    transform: "translate(291 104.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42297",
    "data-name": "Path 42297",
    d: "M72.031,8.035H99.99v38.61H72.031Zm0,0",
    transform: "translate(-66.037 -7.334)",
    fill: "#fd882f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42298",
    "data-name": "Path 42298",
    d: "M48.031.035H79.984V1.366H48.031Zm0,2.663H79.984V4.029H48.031Zm0,11.983H79.984v1.331H48.031Zm0,11.983H79.984v1.331H48.031Zm0,0",
    transform: "translate(-44.034 0)",
    fill: "#fd882f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42299",
    "data-name": "Path 42299",
    d: "M12.025,420.695H9.362l-1.331-4.66h5.326Zm0,0",
    transform: "translate(-7.362 -381.384)",
    fill: "#dee1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42300",
    "data-name": "Path 42300",
    d: "M13.35,238.675a2.607,2.607,0,0,0-.373-1.347,1.242,1.242,0,0,1-.005-1.291,2.66,2.66,0,1,0-4.947-1.356,2.608,2.608,0,0,0,.373,1.346,1.255,1.255,0,0,1,0,1.3,2.615,2.615,0,0,0,0,2.693,1.242,1.242,0,0,1,.005,1.291,2.66,2.66,0,1,0,4.948,1.356,2.612,2.612,0,0,0-.373-1.346,1.255,1.255,0,0,1,0-1.3A2.612,2.612,0,0,0,13.35,238.675Zm0,0",
    transform: "translate(-7.355 -212.678)",
    fill: "#88b337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42301",
    "data-name": "Path 42301",
    d: "M32.031,264.035h1.331v12.648H32.031Zm0,0",
    transform: "translate(-29.365 -242.032)",
    fill: "#a3603e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42302",
    "data-name": "Path 42302",
    d: "M412.025,420.695h-2.663l-1.331-4.66h5.326Zm0,0",
    transform: "translate(-374.078 -381.384)",
    fill: "#dee1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42303",
    "data-name": "Path 42303",
    d: "M413.35,238.675a2.608,2.608,0,0,0-.373-1.347,1.241,1.241,0,0,1-.005-1.291,2.66,2.66,0,1,0-4.947-1.356,2.608,2.608,0,0,0,.373,1.346,1.255,1.255,0,0,1,0,1.3,2.615,2.615,0,0,0,0,2.693,1.242,1.242,0,0,1,.005,1.291,2.66,2.66,0,1,0,4.948,1.356,2.611,2.611,0,0,0-.373-1.346,1.255,1.255,0,0,1,0-1.3A2.611,2.611,0,0,0,413.35,238.675Zm0,0",
    transform: "translate(-374.071 -212.678)",
    fill: "#88b337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42304",
    "data-name": "Path 42304",
    d: "M432.031,264.035h1.331v12.648h-1.331Zm0,0",
    transform: "translate(-396.081 -242.032)",
    fill: "#a3603e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58420",
    "data-name": "Group 58420",
    transform: "translate(5.994 6.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42305",
    "data-name": "Path 42305",
    d: "M72.031,81.366h2V82.7h-2Zm9.985,2h2v1.331h-2Zm15.977,2h2v1.331h-2Zm-8.654-5.326H90.67v1.331H89.339ZM90,92.018h2v1.331H90Zm-16.642,4.66h1.331v1.331H73.362Zm15.311,2H90v1.331H88.673ZM97.993,104h1.331v1.331H97.993Zm-15.977,3.994h1.331v1.331H82.016ZM74.694,85.361h2v1.331h-2Zm0,0",
    transform: "translate(-72.031 -80.035)",
    fill: "#ef701b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_42306",
    "data-name": "Path 42306",
    d: "M120.031,72.035h3.994v6.657h-3.994Zm0,0",
    transform: "translate(-110.043 -66.009)",
    fill: "#a12a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42307",
    "data-name": "Path 42307",
    d: "M120.031,72.035h3.994v3.328h-3.994Zm0,0",
    transform: "translate(-110.043 -66.009)",
    fill: "#dee1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42308",
    "data-name": "Path 42308",
    d: "M120.031,72.035h3.994v1.331h-3.994Zm0,0",
    transform: "translate(-110.043 -66.009)",
    fill: "#c0c3c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42309",
    "data-name": "Path 42309",
    d: "M216.031,72.035h3.994v6.657h-3.994Zm0,0",
    transform: "translate(-198.054 -66.009)",
    fill: "#a12a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42310",
    "data-name": "Path 42310",
    d: "M216.031,72.035h3.994v3.328h-3.994Zm0,0",
    transform: "translate(-198.054 -66.009)",
    fill: "#dee1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42311",
    "data-name": "Path 42311",
    d: "M216.031,72.035h3.994v1.331h-3.994Zm0,0",
    transform: "translate(-198.054 -66.009)",
    fill: "#c0c3c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42312",
    "data-name": "Path 42312",
    d: "M312.031,72.035h3.994v6.657h-3.994Zm0,0",
    transform: "translate(-286.066 -66.009)",
    fill: "#a12a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42313",
    "data-name": "Path 42313",
    d: "M312.031,72.035h3.994v3.328h-3.994Zm0,0",
    transform: "translate(-286.066 -66.009)",
    fill: "#dee1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42314",
    "data-name": "Path 42314",
    d: "M312.031,72.035h3.994v1.331h-3.994Zm0,0",
    transform: "translate(-286.066 -66.009)",
    fill: "#c0c3c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42315",
    "data-name": "Path 42315",
    d: "M120.031,216.035h3.994v6.657h-3.994Zm0,0",
    transform: "translate(-110.043 -198.026)",
    fill: "#a12a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42316",
    "data-name": "Path 42316",
    d: "M120.031,216.035h3.994v3.328h-3.994Zm0,0",
    transform: "translate(-110.043 -198.026)",
    fill: "#dee1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42317",
    "data-name": "Path 42317",
    d: "M120.031,216.035h3.994v1.331h-3.994Zm0,0",
    transform: "translate(-110.043 -198.026)",
    fill: "#c0c3c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42318",
    "data-name": "Path 42318",
    d: "M216.031,216.035h3.994v6.657h-3.994Zm0,0",
    transform: "translate(-198.054 -198.026)",
    fill: "#a12a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42319",
    "data-name": "Path 42319",
    d: "M216.031,216.035h3.994v3.328h-3.994Zm0,0",
    transform: "translate(-198.054 -198.026)",
    fill: "#dee1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42320",
    "data-name": "Path 42320",
    d: "M216.031,216.035h3.994v1.331h-3.994Zm0,0",
    transform: "translate(-198.054 -198.026)",
    fill: "#c0c3c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42321",
    "data-name": "Path 42321",
    d: "M312.031,216.035h3.994v6.657h-3.994Zm0,0",
    transform: "translate(-286.066 -198.026)",
    fill: "#a12a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42322",
    "data-name": "Path 42322",
    d: "M312.031,216.035h3.994v3.328h-3.994Zm0,0",
    transform: "translate(-286.066 -198.026)",
    fill: "#dee1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42323",
    "data-name": "Path 42323",
    d: "M312.031,216.035h3.994v1.331h-3.994Zm0,0",
    transform: "translate(-286.066 -198.026)",
    fill: "#c0c3c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42324",
    "data-name": "Path 42324",
    d: "M120.031,360.035h3.994v6.657h-3.994Zm0,0",
    transform: "translate(-110.043 -330.044)",
    fill: "#a12a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42325",
    "data-name": "Path 42325",
    d: "M120.031,360.035h3.994v3.328h-3.994Zm0,0",
    transform: "translate(-110.043 -330.044)",
    fill: "#dee1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42326",
    "data-name": "Path 42326",
    d: "M120.031,360.035h3.994v1.331h-3.994Zm0,0",
    transform: "translate(-110.043 -330.044)",
    fill: "#c0c3c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42327",
    "data-name": "Path 42327",
    d: "M216.031,360.035h3.994v6.657h-3.994Zm0,0",
    transform: "translate(-198.054 -330.044)",
    fill: "#a12a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42328",
    "data-name": "Path 42328",
    d: "M216.031,360.035h3.994v3.328h-3.994Zm0,0",
    transform: "translate(-198.054 -330.044)",
    fill: "#dee1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42329",
    "data-name": "Path 42329",
    d: "M216.031,360.035h3.994v1.331h-3.994Zm0,0",
    transform: "translate(-198.054 -330.044)",
    fill: "#c0c3c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42330",
    "data-name": "Path 42330",
    d: "M312.031,360.035h3.994v6.657h-3.994Zm0,0",
    transform: "translate(-286.066 -330.044)",
    fill: "#a12a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42331",
    "data-name": "Path 42331",
    d: "M312.031,360.035h3.994v1.331h-3.994Zm0,0",
    transform: "translate(-286.066 -330.044)",
    fill: "#912626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42332",
    "data-name": "Path 42332",
    d: "M296.031,440.035h6.657V442.7h-6.657Zm0,0",
    transform: "translate(-271.397 -403.387)",
    fill: "#ff9747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42333",
    "data-name": "Path 42333",
    d: "M.031,464.035H39.973v1.331H.031Zm0,0",
    transform: "translate(-0.028 -425.39)",
    fill: "#c0c2c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42334",
    "data-name": "Path 42334",
    d: "M72.031,16.035H99.99v1.331H72.031Zm0,2.663H99.99v1.331H72.031Zm0,11.983H99.99v1.331H72.031Zm0,11.983H99.99v1.331H72.031Zm0,0",
    transform: "translate(-66.037 -14.669)",
    fill: "#ef701b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42335",
    "data-name": "Path 42335",
    d: "M112.685,71.358a.666.666,0,0,0,.666.666h3.994a.666.666,0,0,0,.666-.666V64.7a.666.666,0,0,0-.666-.666h-3.994a.666.666,0,0,0-.666.666v3.994h-1.331v1.331h1.331Zm1.331-5.991h2.663v2h-2.663Zm0,3.328h2.663v2h-2.663Zm7.323,3.328h3.994a.666.666,0,0,0,.666-.666V64.7a.666.666,0,0,0-.666-.666h-3.994a.666.666,0,0,0-.666.666v6.657A.666.666,0,0,0,121.339,72.023ZM122,65.366h2.663v2H122Zm0,3.328h2.663v2H122Zm-15.977,3.328h3.328a.666.666,0,0,0,.666-.666V64.7a.666.666,0,0,0-.666-.666h-3.994a.666.666,0,0,0-.666.666v5.991h-.666v1.331Zm0-6.657h2.663v2h-2.663Zm0,3.328h2.663v2h-2.663Zm7.323,15.311h3.994a.666.666,0,0,0,.666-.666V76.683a.666.666,0,0,0-.666-.666h-3.994a.666.666,0,0,0-.666.666V83.34A.666.666,0,0,0,113.351,84.006Zm.666-6.657h2.663v2h-2.663Zm0,3.328h2.663v2h-2.663Zm6.657-.666V83.34a.666.666,0,0,0,.666.666h3.994A.666.666,0,0,0,126,83.34V76.683a.666.666,0,0,0-.666-.666h-3.994a.666.666,0,0,0-.666.666v.666h-1.331V78.68h1.331ZM122,77.349h2.663v2H122Zm0,3.328h2.663v2H122Zm-16.642,3.328h3.994a.666.666,0,0,0,.666-.666V76.683a.666.666,0,0,0-.666-.666h-3.994a.666.666,0,0,0-.666.666V83.34a.666.666,0,0,0,.666.666Zm.666-6.657h2.663v2h-2.663Zm0,3.328h2.663v2h-2.663Zm6.657,14.645a.666.666,0,0,0,.666.666h3.994a.666.666,0,0,0,.666-.666V88.666a.666.666,0,0,0-.666-.666h-3.994a.666.666,0,0,0-.666.666v4.66h-1.331v1.331h1.331Zm1.331-5.991h2.663v2h-2.663Zm0,3.328h2.663v2h-2.663Zm-8.654,3.328h3.994a.666.666,0,0,0,.666-.666V88.666a.666.666,0,0,0-.666-.666h-3.994a.666.666,0,0,0-.666.666v6.657a.666.666,0,0,0,.666.666Zm.666-6.657h2.663v2h-2.663Zm0,3.328h2.663v2h-2.663Zm0,0",
    transform: "translate(-95.374 -58.674)",
    fill: "#1b2737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42336",
    "data-name": "Path 42336",
    d: "M39.945,26a3.288,3.288,0,0,0-.466-1.689.576.576,0,0,1-.007-.6,3.321,3.321,0,0,0-4.852-4.359V16.012H35.95V14.68H34.619V4.029H35.95V2.7H34.619V1.366H35.95V.035H4V1.366H5.329V2.7H4V4.029H5.329V14.68H4v1.331H5.329v3.319A3.252,3.252,0,0,0,4.1,18.762,3.332,3.332,0,0,0,0,22a3.283,3.283,0,0,0,.466,1.688.591.591,0,0,1,0,.618,3.281,3.281,0,0,0,0,3.377.574.574,0,0,1,.007.6A3.319,3.319,0,0,0,2.56,33.233c.035.008.067.01.1.018v.735h-2a.666.666,0,0,0-.64.848l1.089,3.812H0v1.331H39.945V38.645H38.83l1.089-3.812a.666.666,0,0,0-.64-.848h-2v-.741a3.309,3.309,0,0,0,2.2-4.94.592.592,0,0,1,0-.618A3.28,3.28,0,0,0,39.945,26ZM4.161,38.645H2.5l-.951-3.328h3.56Zm1.168-4.66H4v-.741a3.3,3.3,0,0,0,1.331-.6Zm0-12a1.942,1.942,0,0,1-.283,1.028,1.911,1.911,0,0,0,0,1.979A1.948,1.948,0,0,1,5.05,27a1.931,1.931,0,0,0,0,1.987A1.971,1.971,0,0,1,4,31.863V22H2.666v9.873A1.993,1.993,0,0,1,1.4,30.492a1.963,1.963,0,0,1,.222-1.512,1.91,1.91,0,0,0,0-1.979,1.948,1.948,0,0,1,0-2.008,1.931,1.931,0,0,0,0-1.987,1.954,1.954,0,0,1-.278-1,1.991,1.991,0,0,1,.752-1.562,1.966,1.966,0,0,1,1.24-.435,2.131,2.131,0,0,1,.48.055A1.985,1.985,0,0,1,5.267,21.5a2.1,2.1,0,0,1,.061.472Zm25.3,16.66H25.3V37.314h5.326Zm-3.994-2.663V30.657h2.663v5.326Zm6.657-5.326H31.956v1.331h1.331v6.657H31.956v-2a.666.666,0,0,0-.666-.666h-.666V29.991a.666.666,0,0,0-.666-.666H25.965a.666.666,0,0,0-.666.666v5.991h-.666a.666.666,0,0,0-.666.666v2H6.66V27.994H33.288Zm0-3.994h-9.32V25.331H22.637v1.331H6.66V16.012H33.288Zm0-14.645H31.956v1.331h1.331V14.68H6.66V9.355H7.991V8.023H6.66V4.029H33.288Zm0-9.32H6.66V1.366H33.288Zm1.331,29.966a3.248,3.248,0,0,0,1.227.569c.035.008.067.01.1.018v.735H34.619ZM38.4,35.317l-.95,3.328H35.787l-.951-3.328Zm-.061-10.324a1.948,1.948,0,0,1,0,2.008,1.931,1.931,0,0,0,0,1.987,1.971,1.971,0,0,1-1.053,2.874V22H35.95v9.873a1.993,1.993,0,0,1-1.27-1.384,2.143,2.143,0,0,1-.061-.475v-.006A1.935,1.935,0,0,1,34.9,28.98,1.91,1.91,0,0,0,34.9,27a1.948,1.948,0,0,1,0-2.008,1.931,1.931,0,0,0,0-1.987,1.954,1.954,0,0,1-.278-1,1.991,1.991,0,0,1,.752-1.562,1.966,1.966,0,0,1,1.24-.435,2.131,2.131,0,0,1,.48.055,1.985,1.985,0,0,1,1.46,1.442,1.961,1.961,0,0,1-.222,1.512,1.911,1.911,0,0,0,0,1.979Zm0,0",
    transform: "translate(0 0)",
    fill: "#1b2737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42337",
    "data-name": "Path 42337",
    d: "M104.008,80.035h1.331v1.331h-1.331ZM88.031,96.677h1.331v1.331H88.031Zm0,0",
    transform: "translate(-80.705 -73.343)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.95d18d9d7e12e7e75faca512bcde2819.svg";
export { ForwardRef as ReactComponent };